import axios from 'axios'
import { ModuleOutputDTO } from './moduleDTO'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class ModuleServices {
  async getById(id: number): Promise<ModuleOutputDTO> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/module/${id}`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
  async getByAll(): Promise<ModuleOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_AUTH}/module`,
      {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
  async getModulesByApplications(id: number): Promise<ModuleOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_AUTH}/module/applicationId/${id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error;
    }
  }
}

export const moduleServices = new ModuleServices()
